import { Grid } from '@mui/material';
import { OtpInput } from 'mui-otp-input';
import { useState } from 'react';
import { VmsAccount, validateOtp } from 'wisestep-api';
import { WsButton, WsDialog, WsTypoColors, WsTypoVariants, WsTypography } from 'wisestep-base';

import { failed, success } from '../../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../../utils/NotificationStore';

export interface IComponentProps {
  openDialog: boolean;
  currentVmsAccount: VmsAccount;
  onClose: () => void;
  handleSuccess: () => void;
  resendOtp: (vmsAccount: VmsAccount) => void;
}

const VerifyOtpDialog = ({
  openDialog,
  currentVmsAccount,
  onClose,
  handleSuccess,
  resendOtp,
}: IComponentProps) => {
  const [otpValue, setOtpValue] = useState<string>('');
  const setNotification = useNotificationStore((state) => state.setNotification);

  const handleOtpChange = (value: string) => {
    setOtpValue(value);
  };

  const verifyOtp = async () => {
    currentVmsAccount.otp = otpValue;
    try {
      const response = await validateOtp(currentVmsAccount);
      if (response.data) {
        setNotification(success('OTP validated successfully'));
        handleSuccess();
        onClose();
      } else {
        setNotification(failed('Incorrect OTP'));
      }
    } catch (error: any) {
      setNotification(failed('Something went wrong while validating OTP'));
    }
  };

  return (
    <WsDialog size="small" openDialog={openDialog} onClose={onClose}>
      <Grid container py={1} justifyContent="center">
        <Grid item xs={12} sm={12} m={2} textAlign="center">
          <WsTypography variant={WsTypoVariants.TITLE} bold={true} color={WsTypoColors.SECONDARY}>
            Please Enter the OTP to Verify your Account
          </WsTypography>
        </Grid>
        <Grid item xs={12} sm={12} m={2} textAlign="center">
          <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.SECONDARY}>
            OTP (one time Password) has been sent to &quot;{currentVmsAccount?.whiteListEmail}
            &quot;
          </WsTypography>
        </Grid>
        <Grid item xs={12} sm={10} m={2} textAlign="center">
          <OtpInput type="numeric" value={otpValue} onChange={handleOtpChange} format="______" />
        </Grid>
        <Grid item xs={12} sm={10} m={2} textAlign="center">
          <WsButton
            variant="contained"
            disabled={otpValue.length < 6}
            size="large"
            onClick={verifyOtp}
          >
            Verify OTP
          </WsButton>
        </Grid>
        <Grid item xs={12} sm={10} m={1} textAlign="center">
          <WsButton variant="text" size="large" onClick={() => resendOtp(currentVmsAccount)}>
            Resend OTP
          </WsButton>
        </Grid>
      </Grid>
    </WsDialog>
  );
};

export default VerifyOtpDialog;
